import React from "react";
import {
  IconLockOutline,
  withTooltip,
  THEMES,
  TOOLTIP_HORIZONTAL_ALIGNMENTS,
  TOOLTIP_VERTICAL_ALIGNMENTS,
} from "cdk-radial";

const VerifiedUserIcon = (props) => {
  return (
    <svg 
      {...props}
      className="api-dir-pkg_icons"
      data-testid="icon-private-api"
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      fill="currentColor"
    >
      <path d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59 2.41L9 11.83l2 2 4-4 1.41 1.41L11 16.64l-3.59-3.23z"/>
    </svg>
  );
};

const PrivateIcon = () => {
  const compwithToolTip = (props) => {
    return <IconLockOutline {...props} className="api-dir-pkg_icons" data-testid="icon-private-api" />;
  };

  const Component = withTooltip(compwithToolTip, {
    id: `private-icon`,
    text: "Private",
    theme: THEMES.LIGHT,
  });
  return (
    <Component
      style={{ display: 'inline' }}
      horizontalAlignment={TOOLTIP_HORIZONTAL_ALIGNMENTS.RIGHT}
      verticalAlignment={TOOLTIP_VERTICAL_ALIGNMENTS.TOP}
    />
  );
};

export { PrivateIcon };
